import React from 'react'
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import Alert, { Alert2 } from '../../components/Alerte';
import Input from '../../components/Input';
import InputT from '../../components/Input';
import { InputF } from '../../components/Input';
import { Form, Button, Spinner } from 'react-bootstrap';
import AlerteMessage from '../../components/AlerteMessage';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import Env from '../../hooks/Env';

const UpdateEtranger = () => {
    useDocumentTitle('Mise à jour Admission Étranger');
    const { uid } = useParams();
    const navigate = useNavigate();
    const API_URL = Env().API_URL;

    const [dataForm, setDataForm] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [typefille, setTypeFile] = useState(false);
    const [messageAlerte, setMessageAlerte] = useState('');
    const [success, setSuccess] = useState(false);
    const maxFileSize = 1024 * 1024 * 2; // 2Mo
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleClose3 = () => setOpen(false);

    const [selectedFiles, setSelectedFiles] = useState({
        "cv": true,
        "copie_carte_id": true,
        "demande": true,
        "motivation": true,
        "copie_diplome": true,
        "diplome_bac": true,
    });
    const [gestionfichier, setGestionFichier] = useState({
        "cv": false,
        "copie_carte_id": false,
        "demande": false,
        "motivation": false,
        "copie_diplome": false,
        "diplome_bac": false,
    });
    const [submitted, setSubmitted] = useState(false);
    const [valid, SetIsValid] = useState({
        isValidPhoneNumber: true,
    });

    // Récupérer les données existantes
    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await axios.get(`${API_URL}/admission/uid/${uid}`);

                if (response.status === 200 && response.data) {
                    setDataForm(response.data);
                    if (response.data.telephone) {
                        const phoneRegex = /^\d{9}$/;
                        SetIsValid((valid) => ({
                            ...valid,
                            isValidPhoneNumber: phoneRegex.test(response.data.telephone),
                        }));
                    }
                    setLoading(false);
                } else {
                    setError("Impossible de récupérer les données");
                    setLoading(false);
                }
            } catch (err) {
                console.error('Erreur lors de la récupération des données:', err);
                setError("Une erreur s'est produite lors de la récupération des données");
                setLoading(false);
            }
        };

        if (uid) {
            fetchData();
        }
    }, [uid, API_URL]);

    const handleFileChange = (event, key) => {
        var file = event.target.files[0];
        const elements = document.getElementsByName(key);

        if (file?.type === "application/pdf") {
            if (file?.size < maxFileSize) {
                setTypeFile(false);
                setSelectedFiles((prevSelectedFiles) => ({
                    ...prevSelectedFiles,
                    [key]: file
                }));
                setGestionFichier((prevSelectedFiles) => ({
                    ...prevSelectedFiles,
                    [key]: true
                }));
                for (var i = 0; i < elements.length; i++) {
                    var element1 = elements[i];
                    element1.style.border = "";
                }
            } else {
                setGestionFichier((prevSelectedFiles) => ({
                    ...prevSelectedFiles,
                    [key]: false
                }));
                setSelectedFiles((prevSelectedFiles) => ({
                    ...prevSelectedFiles,
                    [key]: false
                }));
                for (var j = 0; j < elements.length; j++) {
                    var element2 = elements[j];
                    element2.style.border = "2px solid #BC0C0C";
                    element2.style.transition = 'border 0.5s ease-in-out;'
                }
            }
        } else if (file) {
            setOpen(true);
            setMessage("format de fichier non permis");
            setSelectedFiles((prevSelectedFiles) => ({
                ...prevSelectedFiles,
                [key]: false
            }));
            setGestionFichier((prevSelectedFiles) => ({
                ...prevSelectedFiles,
                [key]: false
            }));
        }
    };

    function handleChange(e) {
        const name = e.target.name;
        let value = e.target.value;

        if (name === 'telephone') {
            const phoneRegex = /^\d{9}$/;
            SetIsValid((valid) => ({
                ...valid,
                isValidPhoneNumber: phoneRegex.test(value),
            }));
        }
        setDataForm({ ...dataForm, [name]: value });
    }

    const handleSubmit = async (e) => {
        try {
            e.preventDefault();
            const formData = new FormData();
            formData.append('uid', uid);

            const nameFiles = ["cv", "copie_carte_id", "demande", "motivation", "copie_diplome", "diplome_bac"];
            for (const i in nameFiles) {
                if (gestionfichier[nameFiles[i]] && selectedFiles[nameFiles[i]] instanceof File) {
                    if (selectedFiles[nameFiles[i]].size <= maxFileSize) {
                        formData.append(nameFiles[i], selectedFiles[nameFiles[i]]);
                    }
                }
            }

            for (let key in dataForm) {
                if (dataForm.hasOwnProperty(key)) {
                    if (dataForm[key] !== null && !nameFiles.includes(key) && key !== 'date_depot') {
                        formData.append(key, dataForm[key]);
                    }
                }
            }

            var showALerte = nameFiles.some(field => selectedFiles[field] === false);

            if (!valid.isValidPhoneNumber) {
                setMessageAlerte('Numéro de téléphone incorrect');
                setShow(true);
            } else if (showALerte) {
                setShow(true);
            } else if (typefille) {
                alert('Format de fichier incorrect !');
            } else {
                setSubmitted(true);

                const response = await axios.post(
                    `${API_URL}/admission/update`,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    }
                );
                if (response.status === 200) {
                    setSubmitted(false);
                    setSuccess(true);
                    setMessage('Mise à jour effectuée avec succès !');
                } else {
                    setSubmitted(false);
                    setOpen(true);
                    setMessage('Erreur lors de la mise à jour');
                }
            }
        } catch (error) {
            setSubmitted(false);
            console.error('Error', error);
            setOpen(true);
            setMessage('Une erreur s\'est produite lors de la mise à jour');
        }
    };

    if (loading) {
        return (
            <div className='container text-center mt-5'>
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Chargement...</span>
                </Spinner>
                <p>Chargement des données...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className='container mt-5'>
                <Alert2 message={error} />
            </div>
        );
    }

    if (success) {
        return (
            <div className='container mt-5'>
                <Alert2 message="Mise à jour effectuée avec succès !" />
                <div className='text-center mt-3'>
                    <Button variant="primary" onClick={() => navigate('/')}>
                        Retour à l'accueil
                    </Button>
                </div>
            </div>
        );
    }

    return (
        <div className='container mb-2' id='mainDepot'>
            <AlerteMessage open={open} handleClose={handleClose3} message={message} />
            <Alert show={show} handleClose={handleClose} />

            <div id='nameModule' className=''>
                <p>Mise à jour - Admission Étranger</p>
            </div>

            <Form onSubmit={handleSubmit}>
                <div id="step1" className='mb-3'>
                    <Form.Group>
                        <div className='d-inline'>
                            <span style={{ 'fontWeight': '500' }}>Civilité</span> <br />
                            <Form.Check
                                inline
                                type="radio"
                                label="Monsieur"
                                value='Monsieur'
                                required
                                checked={dataForm.civilite === 'Monsieur'}
                                name="civilite"
                                onChange={handleChange}
                            />
                        </div>
                        <div className='d-inline'>
                            <Form.Check
                                inline
                                type="radio"
                                label="Madame"
                                value='Madame'
                                checked={dataForm.civilite === 'Madame'}
                                required
                                name="civilite"
                                onChange={handleChange}
                            />
                        </div>
                    </Form.Group>
                    <div className='row' id='test'>
                        <Input placeholder='email' className="col-md-6 col-sm-12" value={dataForm.email || ''} type='text' label="Adresse email" name='email' onChange={handleChange} disabled />
                        <Input placeholder='prenom' className="col-md-6 col-sm-12" value={dataForm.prenom || ''} type='text' label="Prénom (s)" name='prenom' onChange={handleChange} />
                        <Input placeholder='nom' className="col-md-6 col-sm-12" value={dataForm.nom || ''} type='text' label="Nom" name='nom' onChange={handleChange} />
                    </div>
                    <div className='row'>
                        <Input className="col-md-6 col-sm-12" value={dataForm.date_naissance || ''} type='date' label="Date de Naissance" name='date_naissance' onChange={handleChange} />
                        <Input className="col-md-6 col-sm-12" value={dataForm.lieu_naissance || ''} type='text' label="Lieu de naissance" name='lieu_naissance' onChange={handleChange} />
                    </div>
                    <InputT placeholder='XXXXXXXXX' type='number' value={dataForm.telephone || ''} label="Téléphone" name='telephone' onChange={handleChange} />
                    {!valid.isValidPhoneNumber ? <span style={{ color: 'red' }}>{messageAlerte} </span> : null}
                    <Input placeholder='Dakar' type='text' value={dataForm.address || ''} label="Adresse" name='address' onChange={handleChange} />
                </div>

                <div id="step2">
                    <Form.Group id='serie'>
                        <Form.Label className='fw-medium'>Département <span style={{ color: 'red' }}>*</span></Form.Label>
                        <Form.Select name='cycle' required value={dataForm.cycle || ''} onChange={handleChange}>
                            <option key='' value="">--- Selectionner ---</option>
                            <option key='sti' value="STI">Sciences et Techniques de l'Ingénieur</option>
                            <option key='stan' value="STAN">Sciences et Techniques Agricoles,Alimentaires et Nutritionnelles</option>
                            <option key='u2adt' value="U2ADT">Urbanisme, Architecture et Aménagement durable des Territoires</option>
                            <option key='gae' value="GAE">Géosciences Appliquées et Environnement</option>
                            <option key='go' value="GO">Gestion des Organisations</option>
                        </Form.Select>
                    </Form.Group>
                    <Form.Group id='serie'>
                        <Form.Label className='fw-medium'>Filière <span style={{ color: 'red' }}>*</span></Form.Label>
                        <Form.Select name='filiere' required value={dataForm.filiere || ''} onChange={handleChange}>
                            <option key='' value="">--- Selectionner ---</option>
                            <option key='GP' value="GP">Génie des Procédés</option>
                            <option key='IGC' value="IGC">Infrastructures et Génie Civil</option>
                            <option key='2I' value="2I">Ingénierie Informatique</option>
                            <option key='S2E' value="S2E">Systèmes Électriques et Énergétiques</option>
                            <option key='S2A' value="S2A">Sciences Agricoles et Alimentaires</option>
                            <option key='UAT' value="UAT">Urbanisme et Aménagement</option>
                            <option key='AR' value="AR">Architecture</option>
                            <option key='MG' value="MG">Mines et Géologie</option>
                            <option key='ENV' value="ENV">Environnement</option>
                            <option key='HA' value="HA">Hydraulique et Assainissement</option>
                            <option key='EGO' value="EGO">Géomatique</option>
                            <option key='FC' value="FC">Finance et Comptabilité</option>
                            <option key='MO' value="MO">Management des Organisations</option>
                        </Form.Select>
                    </Form.Group>
                </div>

                <InputF className="rounded-left mb-2" label="Copie légalisée BAC" message={dataForm.diplome_bac ? <span style={{ color: 'green' }}>(Fichier existant)</span> : <span style={{ color: 'red' }}>*</span>} type='file' name='diplome_bac' onChange={(e) => handleFileChange(e, "diplome_bac")} />
                {!selectedFiles["diplome_bac"] ? <span style={{ color: 'red' }}>taille du fichier {'>'} 2 Mo veuillez le réduire. </span> : null}

                <InputF id="copie_carte" className="rounded-left mb-2" label="Copie légalisée du passport" message={dataForm.copie_carte_id ? <span style={{ color: 'green' }}>(Fichier existant)</span> : <span style={{ color: 'red' }}>*</span>} type='file' name='copie_carte_id' onChange={(e) => handleFileChange(e, "copie_carte_id")} />
                {!selectedFiles["copie_carte_id"] ? <span style={{ color: 'red' }}>taille du fichier {'>'} 2 Mo veuillez le réduire. </span> : null}

                <InputF className="rounded-left mb-2" label="Copie du relevé de notes au baccalauréat" message={dataForm.cv ? <span style={{ color: 'green' }}>(Fichier existant)</span> : <span style={{ color: 'red' }}>*</span>} type='file' name='cv' onChange={(e) => handleFileChange(e, "cv")} />
                {!selectedFiles["cv"] ? <span style={{ color: 'red' }}>taille du fichier {'>'} 2 Mo veuillez le réduire. </span> : null}

                <InputF className="rounded-left mb-2" label="Copies des bulletins de classes de Seconde, Première et Terminale" message={dataForm.demande ? <span style={{ color: 'green' }}>(Fichier existant)</span> : <span style={{ color: 'red' }}>*</span>} type='file' name='demande' onChange={(e) => handleFileChange(e, "demande")} />
                {!selectedFiles["demande"] ? <span style={{ color: 'red' }}>taille du fichier {'>'} 2 Mo veuillez le réduire. </span> : null}

                <InputF className="rounded-left mb-2" label="Copies des bulletins de classes de Seconde, Première et Terminale" message={dataForm.motivation ? <span style={{ color: 'green' }}>(Fichier existant)</span> : <span style={{ color: 'red' }}>*</span>} type='file' name='motivation' onChange={(e) => handleFileChange(e, "motivation")} />
                {!selectedFiles["motivation"] ? <span style={{ color: 'red' }}>taille du fichier {'>'} 2 Mo veuillez le réduire. </span> : null}

                <InputF className="rounded-left mb-2" label="Copies des bulletins de classes de Seconde, Première et Terminale" message={dataForm.copie_diplome ? <span style={{ color: 'green' }}>(Fichier existant)</span> : <span style={{ color: 'red' }}>*</span>} type='file' name='copie_diplome' onChange={(e) => handleFileChange(e, "copie_diplome")} />
                {!selectedFiles["copie_diplome"] ? <span style={{ color: 'red' }}>taille du fichier {'>'} 2 Mo veuillez le réduire. </span> : null}

                <div>
                    <Button variant="primary" type='submit' size="md"
                        style={{ paddingBottom: '30px', marginBottom: '30px' }}
                        className="p-2 float-end m-3">
                        Mettre à jour {submitted ?
                            <Spinner animation="grow"
                                size="sm" role="status"
                            >
                                <span className="visually-hidden">Loading...</span>
                            </Spinner>
                            : null}
                    </Button>
                </div>
            </Form>
        </div>
    );
}

export default UpdateEtranger;
